<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row">
      <div class="col">
        <fccTable
          pdf
          csv
          xls
          striped
          hover
          :fields="fields"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actions"
          :optionsButton="optionsButton"
          :items="items"
        >
        </fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      titlePage: 'Acompanhamento de Projetos',
      fields: [
        { key: 'idprojeto', label: 'ID', sortable: true, active: true },
        { key: 'descricao', label: 'Título', sortable: true, active: true },
        { key: 'sistema', label: 'Sistema', sortable: true, active: true },
        { key: 'nomefuncionariosolicitante', label: 'Solicitante', sortable: true, active: true },
        { key: 'dtinicio', label: 'Data de Início', sortable: true, active: true },
        { key: 'dtentrega', label: 'Data de Entrega', sortable: true, active: true },
        { key: 'situacao', label: 'Situação', sortable: true, active: true },
        { key: 'actions', label: '', thClass: 'no-print', tdClass: 'text-nowrap no-print' }
      ],
      itemPorPage: 10,
      titlePDF: 'Lista de Projetos',
      actions: [
        {
          button: true,
          funcaoButton: this.editarProjeto,
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      optionsButton: [
        {
          funcaoButton: 'adicionarProjeto',
          tooltip: 'Adicionar',
          icon: 'plus',
          text: 'Adicionar projeto',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      items: []
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['situacoesProjeto', 'allProjetos'])
  },
  mounted() {
    this.carregaTexto(this.codeMensagem('C01'))
    store
      .dispatch(
        'acompanhamentoDeProjetos/fetchSituacoesProjeto',
        this.dadosLoginSession.fccTokenHeaders
      )
      .then(this.listarTipoPublicacao)
      .catch(this.setErrorSystem)
      .finally(this.carregaTexto)
  },
  methods: {
    editarProjeto(_, projeto) {
      this.$router.push({
        path: `/acompanhamento-projetos/editar-projeto/${projeto.idprojeto}`
      })
    },
    listarTipoPublicacao() {
      return store
        .dispatch(
          'acompanhamentoDeProjetos/fetchAllProjetos',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.items = this.allProjetos.map((item) => ({
            ...item,
            situacao: this.situacoesProjeto.find(
              (situacao) => situacao.tpsituacaoprojeto === item.tpsituacaoprojeto
            ).descricao
          }))
        })
    },
    adicionarProjeto() {
      this.$router.push({ path: '/acompanhamento-projetos/adicionar-projeto' })
    }
  }
}
</script>